export var TypeActionError;
(function (TypeActionError) {
    TypeActionError["Throw"] = "Error > Throw";
    TypeActionError["Resolve"] = "Error > Resolve";
    TypeActionError["ResolveAll"] = "Error > ResolveAll";
})(TypeActionError || (TypeActionError = {}));
export var actionErrorThrowError = function (errorKey, statusCode) { return ({
    errorKey: errorKey,
    statusCode: statusCode,
    type: TypeActionError.Throw,
}); };
export var actionErrorResolveError = function (errorKey) { return ({
    errorKey: errorKey,
    type: TypeActionError.Resolve,
}); };
export var actionErrorResolveAllErrors = function (errorKey) { return ({
    errorKey: errorKey,
    type: TypeActionError.ResolveAll,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/actionError.ts
// module id = 147
// module chunks = 3